import { TApplicationState } from '../../types/redux';

export const getAllPromos = (state: TApplicationState) => {
  return state.newbuilding.promoInfos || [];
};
